import { FC } from 'react';
import styles from './RetellingSticker.module.scss';

const RetellingSticker: FC = () => {
  return <span className={styles.retellingSticker}>Краткий пересказ</span>;
};

export default RetellingSticker;
